import { Divider, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import React, { useState } from "react";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import Close from '@mui/icons-material/Close';

import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';

const EmployeeActionMenu = ({ selectedButtonName, setSelectedButtonName, handlecallProcess, enableRejectParentRoll, title, callback,saveButtonDisabled}) => {

    const [selectedButton, setSelectedButton] = useState(null);
    const [viewParentRollDetail, setViewParentRollDetail] = useState(false);

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
        setSelectedButtonName(buttonName);

        handlecallProcess(buttonName);
        if (buttonName === 'PDF') {
            setViewParentRollDetail(true);
        }
        else if (buttonName === 'ViewParentRollDetail') {
            setViewParentRollDetail(false);
        }

        if (buttonName == 'QRCode' && viewParentRollDetail === false) {
            setViewParentRollDetail(true);
        }

    };
    return (

        // <Grid container
        //     justifyContent="flex-end"
        //     alignItems="center"
        //     // spacing={1} 
        //     padding={0}>




        //     <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
        //     <Grid item md={0} ml="5px" mr="5px">
        //         <Tooltip title="Add new orders">
        //             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        //                 <IconButton onClick={() => handleButtonClick('QRCode')}>
        //                     <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'QRCode' ? "yellow" : "#009688" }} />
        //                     <Typography variant="h6" sx={{ marginLeft: "5px" }}>Save</Typography>
        //                 </IconButton>

        //             </div>
        //         </Tooltip>
        //     </Grid>

        //     <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
        //     <Grid item md={0} ml="5px" mr="5px">
        //         <Tooltip title="Add new orders">
        //             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        //                 <IconButton onClick={() => handleButtonClick('QRCode')}>
        //                     <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'QRCode' ? "yellow" : "#009688" }} />
        //                     <Typography variant="h6" sx={{ marginLeft: "5px" }}>Exit Employee</Typography>
        //                 </IconButton>

        //             </div>
        //         </Tooltip>
        //     </Grid>


        //     <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />
        //     <Grid item md={0} ml="5px" mr="5px">
        //         <Tooltip title="Add new orders">
        //             <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        //                 <IconButton onClick={() => handleButtonClick('QRCode')}>
        //                     <ReceiptRoundedIcon style={{ fontSize: "18px", color: selectedButton === 'QRCode' ? "yellow" : "#009688" }} />
        //                     <Typography variant="h6" sx={{ marginLeft: "5px" }}>Cancel</Typography>
        //                 </IconButton>

        //             </div>
        //         </Tooltip>
        //     </Grid>
        //     <Divider orientation="vertical" flexItem sx={{ marginLeft: "2px", marginRight: "2px" }} />

        // </Grid>

        <Grid container justifyContent="space-between" alignItems="center" padding={0}>
            {/* Left-aligned: Edit Employee */}
            <Grid item>
                <Typography variant="h4" sx={{ textAlign: "center", width: "100%",marginLeft:"10px",alignItems:"center" }}>
                    {title === 0 ? 'New Employee' : 'Edit Employee'}
                </Typography>
            </Grid>

            {/* Right-aligned: Buttons */}
            <Grid item>
                <Grid container alignItems="center">
                <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    {/* Save */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Add new orders">
                            <IconButton
                                onClick={() => handleButtonClick('save')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                                type="submit"
                                disabled={saveButtonDisabled}
                            >
                                <SaveAltIcon style={{ fontSize: "18px", color: selectedButton === 'save' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Save</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>
                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Exit Employee */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Employee compansation Details">
                            <IconButton
                                onClick={() => handleButtonClick('compansation')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <CurrencyRupeeIcon style={{ fontSize: "18px", color: selectedButton === 'compansation' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Employee Compansation</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>         

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />

                    {/* Exit Employee */}
                    <Grid item ml={1} mr={1}>
                        <Tooltip title="Add new orders">
                            <IconButton
                                onClick={() => handleButtonClick('QRCode')}
                                sx={{ display: 'flex', alignItems: 'center' }}
                            >
                                <DirectionsRunIcon style={{ fontSize: "18px", color: selectedButton === 'QRCode' ? "yellow" : "#009688" }} />
                                <Typography variant="body2" sx={{ ml: 1 }}>Exit Employee</Typography>
                            </IconButton>
                        </Tooltip>
                    </Grid>                   

                    <Divider orientation="vertical" flexItem sx={{ mx: 1 }} />
                    <IconButton onClick={callback}>                       
                        <Close style={{ fontSize: "14px", color: "#2196F3" }} />
                    </IconButton>
                    <Divider orientation="vertical" flexItem 
                    // sx={{ mx: 1 }} 
                    />
                </Grid>
            </Grid>
        </Grid>


    )
};
export default EmployeeActionMenu;